import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBooleanOrDefault } from '../helpers'
import { IControlProps } from '../types/IFormSettings'
import { updateFormControlValueAction } from '../actions/formActions'
import { controlSelector } from '../selectors/formBuilder.selector'
import { IOption } from '../types'

function RadioButtons({ controlName, formName }: IControlProps) {
	const dispatch = useDispatch()
	const {
		value: currentValue,
		readonly,
		options,
		customClass,
	} = useSelector(controlSelector(formName, controlName))

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.currentTarget
		const newValue = getBooleanOrDefault(value)

		dispatch(
			updateFormControlValueAction({
				formName,
				value: newValue,
				controlName,
			}),
		)
	}

	return (
		<>
			{((options as IOption[]) || []).map(({ value, label }, i) => {
				return (
					// eslint-disable-next-line react/no-array-index-key
					<React.Fragment key={i}>
						<div
							className={
								customClass
									? 'formRadioButtonContainer ' + customClass
									: 'formRadioButtonContainer'
							}>
							<input
								type="radio"
								className="autovalidate suppress d-none"
								checked={String(value) === String(currentValue)}
								value={value}
								id={`rbn_${controlName}_${value}`}
								name={`rbn_${controlName}_${value}`}
								data-value={value}
								onChange={onChangeHandler}
								readOnly={readonly}
							/>
							<label
								htmlFor={`rbn_${controlName}_${value}`}
								className="control-label">
								<span className="icon" />
								{label ? (
									<div
										dangerouslySetInnerHTML={{
											__html: label,
										}}
									/>
								) : (
									<div>{value}</div>
								)}
							</label>
						</div>
					</React.Fragment>
				)
			})}
		</>
	)
}

export default RadioButtons
